import { PostIndi, useFamilyTreeAddReport } from '@ltvco/refresh-lib/fmt';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { type Record } from '@ltvco/refresh-lib/v1';
import {
  ConsolidatedSearchResultCard,
  NoResultsFound,
} from '@ltvco/refresh-lib/v2';
import React, { Fragment } from 'react';

import { useSearchPersonResultsContext } from '../context';

import { MasonryCardsContainer } from './MasonryCardsContainer';
import { MobilePersonCard as MobilePersonCardVariation1 } from './NewCardsDesignVariation1/PersonCards/MobilePersonCard';

interface PersonCardProps {
  searchPersonResult: Record[];
}

export const PersonCards = ({ searchPersonResult }: PersonCardProps) => {
  const { isMobile } = useScreenSize();
  const { meetMobileCardInDesktopCriteria } = useSearchPersonResultsContext();
  const { handleAddToFamilyTree, isReportInTree, isCreatingFamilyTree } =
    useFamilyTreeAddReport();

  const Container = meetMobileCardInDesktopCriteria
    ? MasonryCardsContainer
    : Fragment;

  if (!searchPersonResult || searchPersonResult.length === 0) {
    return <NoResultsFound />;
  }

  return (
    <Container>
      {searchPersonResult.map((person: Record, index: number) => {
        const allBvIds = Array.isArray(person.relativesNotSerialized)
          ? person.relativesNotSerialized
              .map((relative) => relative.bvid)
              .join(', ')
          : '';
        const reportBvId = person.bvid;
        const reportInFamilyTree = isReportInTree(reportBvId, 'bvid');

        if (isMobile || meetMobileCardInDesktopCriteria) {
          return (
            <Fragment key={index}>
              <MobilePersonCardVariation1
                {...person}
                personData={person}
                reportInTree={reportInFamilyTree}
                isCreatingFamilyTree={isCreatingFamilyTree}
                handleAddToFamilyTree={(postIndi: PostIndi) =>
                  handleAddToFamilyTree(postIndi, person.bvid, 'bvid')
                }
              />
            </Fragment>
          );
        }

        return (
          <ConsolidatedSearchResultCard
            key={index}
            {...person}
            personData={person}
            isConsolidatedSearch={true}
            relativeBvId={allBvIds}
            reportInTree={reportInFamilyTree}
            isCreatingFamilyTree={isCreatingFamilyTree}
            tabName="Person Records"
            handleAddToFamilyTree={(postIndi: PostIndi) =>
              handleAddToFamilyTree(postIndi, person.bvid, 'bvid')
            }
          />
        );
      })}
    </Container>
  );
};
